<template>
  <div class="b-dropdown" :class="[activeClass, mobileClass]" ref="dropdown">
    <div class="b-dropdown__label" @click="toggleOptions">
      {{ dropdownlabelText }}
    </div>

    <div class="b-dropdown__options" v-if="showOptions">
      <ul>
        <li v-if="!isMobile">
          <label>
            <input type="radio" @change="reset()" />
            {{ this.label }}
          </label>
        </li>
        <li v-for="(option, i) in options" :key="i">
          <label
            :for="option.id"
            :class="option.label === selectedOption ? 'selected' : ''">
            <span v-if="option.label === selectedOption && isMobile" class="b-dropdown__close" 
            @click="resetOption"></span>
            <input
              type="radio"
              :id="option.id"
              :value="option.label"
              v-model="selectedOption"
              @change="selectDropdown(option.id)" />
            {{ option.label }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    options: {
      type: Array,
    },
    label: {
      type: String,
    },
    isMobile: {
      type: Boolean,
    },
  },
  data() {
    return {
      showOptions: false,
      selectedOption: '',
    }
  },
  computed: {
    activeClass() {
      return this.showOptions ? 'active' : ''
    },
    dropdownlabelText() {
      return this.selectedOption === '' ? this.label : this.selectedOption
    },
    mobileClass() {
      return this.isMobile ? 'b-dropdown--mob' : ''
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleOptions() {
      this.showOptions = !this.showOptions
    },
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showOptions = false
      }
    },
    selectDropdown(id) {
      this.$emit('select-dropdown', id)
        this.showOptions = false
        
    },
    reset() {
      this.$emit('reset')
      this.selectedOption = ''
      this.showOptions = false
    },

    resetOption(){
       this.selectedOption = ''
          this.$emit('reset')
    }
  },
}
</script>
